/* eslint-disable */
// 导出页面为PDF格式
import html2canvas from 'html2canvas'
import JSPDF from 'jspdf'
import { truncate } from 'lodash'
/***
 * elementName: 需要输出PDF的页面id
 * htmlTitle: 页面标题
 * currentTime：创建时间
 * direction: 页面方向portrait-纵向，landscape-横向
 */
export default async function (elementNames, htmlTitle, currentTime, direction = 'portrait') {
  console.log(elementNames)
  let pdf = new JSPDF(direction, 'mm', 'a4') // A4纸，纵向
  pdf.setDisplayMode('fullwidth', 'continuous', 'FullScreen');
  console.log(pdf.canvas)
  for (let i = 0; i < elementNames.length;) {
    let elementName = elementNames[i]
    console.log('init page' + (i + 1), elementName)
    await ((elementName) => {
      return new Promise((resolve, reject) => {
        renderPage(pdf, elementName, direction).then(() => {
          resolve()
        }).catch(e => {
          reject(e)
        })
      })
    })(elementName).then(() => {
      i++
    }).catch(err => {
      throw err
    })
    if (i >= elementNames.length) {
      pdf.deletePage(elementNames.length + 1)
      pdf.save(htmlTitle + currentTime)
      return Promise.resolve()
    }
  }
}

const renderPage = (pdf, elementName, direction = 'portrait') => {
  return new Promise((resolve, reject) => {
    try {
      let element = document.getElementById(elementName)
      // console.log(document.body.scrollWidth, window.devicePixelRatio)
      var canvaswidth = 1188 // 840
      var scale = 1
      if (direction === 'landscape') {
        // canvaswidth = Math.floor(257 / 190 * canvaswidth)
      }
      if (document.body.scrollWidth >= 1360 && document.body.scrollWidth < 1440) {
        canvaswidth = canvaswidth * 1.5
        scale = 1.5
      } else if (document.body.scrollWidth >= 1440 && document.body.scrollWidth < 1600) {
        canvaswidth = canvaswidth * 1.4
        scale = 1.4
      } else if (document.body.scrollWidth >= 1600 && document.body.scrollWidth < 1680) {
        canvaswidth = canvaswidth * 1.2
        sacle = 1.2
      } else if (document.body.scrollWidth >= 1680 && document.body.scrollWidth < 1920) {
        canvaswidth = canvaswidth * 1.1
        scale = 1.1
      } else if (document.body.scrollWidth >= 1920) {
        canvaswidth = canvaswidth * 1
      }
      canvaswidth = canvaswidth / window.devicePixelRatio
      // console.log(canvaswidth, element.clientHeight, document.body.scrollWidth)
      let c = document.createElement('canvas')
      //照片高度和宽度是页面元素的两倍
      c.width = element.clientWidth * 2
      c.height = element.clientHeight * 2
      c.getContext('2d').scale(1, 1)
      let opt = {
        logging: true,
        // scale: window.devicePixelRatio,
        // canvas: c,
        scale: 4,
        height: element.clientHeight,
        width: element.clientWidth,
        windowHeight: element.clientHeight * 2,
        windowWidth: element.clientWidth * 2,
        // windowWidth: document.body.scrollWidth / window.devicePixelRatio,
        // windowHeight: document.body.scrollHeight / window.devicePixelRatio,
      }
      html2canvas(element, opt).then(function (canvas) {
        console.log(canvas.width, canvas.height)
        let ctx = canvas.getContext('2d')
        // document.body.appendChild(canvas)
        let a4w = 190
        let a4h = 257 // A4大小，210mm x 297mm，四边各保留20mm的边距
        if (direction === 'landscape') {
          a4w = 277
          a4h = 190
        }
        let imgHeight = Math.floor(a4h * canvas.width / a4w) // 按A4显示比例换算一页图像的像素高度
        console.log(a4h, a4w, imgHeight)
        let renderedHeight = 0
        
        while (renderedHeight < canvas.height) {
          let page = document.createElement('canvas')
          page.width = canvas.width
          page.height = Math.min(imgHeight, canvas.height - renderedHeight) // 可能内容不足一页

          // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          let pageCtx = page.getContext('2d')
          // pageCtx.scale(0.5, 0.5)
          pageCtx.putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0)
          
          pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距

          renderedHeight += imgHeight
          console.log(page.width, page.height, imgHeight, renderedHeight)
          // if (renderedHeight < canvas.height) { pdf.addPage() } // 如果后面还有内容，添加一个空页
          // delete page;
          pdf.addPage()
          resolve()
        }
        if (renderedHeight >= canvas.height) {
          resolve()
        }
      })
    } catch (err) {
      reject(err)
    }
  })
}